module.exports = __webpack_public_path__ + "img/統計学入門_7_3_問題.7221ae58.png";